import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from 'src/environments/environment.local';
import * as formatDataHelpers from 'src/app/modules/dashboard/helpers/format-subscription-data.helpers';
import { KinoSubscription } from '../models/kino-subscription.model';
import { Payment } from '../models/payment.interface';
import { Plan } from '../models/plan.model';
import { PrepaidCard } from '../models/prepaid-card.interface';
import { Voucher } from '../models/voucher.model';
import { SubscriptionPlan } from 'app/models/subscrition-plan.model';

@Injectable({ providedIn: 'root' })
export class SubscriptionsApi {
  private readonly mySubscriptionUrl = environment.api.dashboard.mySubscription;

  constructor(private http: HttpClient) { }

  getActiveSubscription$(
    plans: SubscriptionPlan[]
  ): Observable<KinoSubscription | null> {
    return this.http.get(this.mySubscriptionUrl).pipe(
      map((response: any) => {
        return formatDataHelpers.convertApiDataToSubscription(
          response.data,
          plans
        );
      })
    );
  }

  getFamilyMembers$(): Observable<string[]> {
    return this.http.get(`${this.mySubscriptionUrl}/family`).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getSubscriptionsHistory$(
    plans: SubscriptionPlan[]
  ): Observable<ReadonlyArray<KinoSubscription>> {
    return this.http.get(`${this.mySubscriptionUrl}/history`).pipe(
      map((response: any) => {
        return formatDataHelpers.convertApiDataToSubscriptions(
          response.data,
          plans
        );
      })
    );
  }

  addFamilyMember$(email: string): Observable<any> {
    return this.http.post(`${this.mySubscriptionUrl}/family`, { email });
  }

  deleteFamilyMember$(email: string): Observable<any> {
    return this.http.delete(`${this.mySubscriptionUrl}/family/${email}`);
  }

  // VOUCHERS

  useVoucher$(code: string): Observable<any> {
    return this.http.post(`${this.mySubscriptionUrl}/useVoucher`, { code });
  }

  getVouchersHistory$(): Observable<Voucher[]> {
    return this.http.get(`${this.mySubscriptionUrl}/voucherHistory`).pipe(
      map((response: any) => {
        return formatDataHelpers.convertApiDataToVouchers(response.data);
      })
    );
  }

  getVoucherPdf$(voucherId: number): Observable<Blob> {
    const params = new HttpParams().set('id', voucherId);
    return this.http.get(`${this.mySubscriptionUrl}/voucherPdf`, {
      params,
      responseType: 'blob',
    });
  }

  // PAYMENTS

  getPayments$(subscriptionId: number): Observable<Payment[]> {
    return this.http
      .get(`${this.mySubscriptionUrl}/${subscriptionId}/payments`)
      .pipe(
        map((apiData: { data: any[] }) => {
          return formatDataHelpers.convertApiMetaDataToPayments(apiData);
        })
      );
  }

  getPrepaidCards$(subscriptionId: number): Observable<PrepaidCard[]> {
    return this.http
      .get(`${this.mySubscriptionUrl}/${subscriptionId}/vouchers`)
      .pipe(
        map((apiData: { data: any[] }) => {
          return formatDataHelpers.convertApiMetadataToPrepaidCard(apiData);
        })
      );
  }
}
